import React from "react";
import { Button, ButtonGroup, Dropdown, Spinner, Stack } from "react-bootstrap";
import { Download } from "react-bootstrap-icons";

type ProcessBarProps = {
    processing?: boolean;
    preparing?: boolean;
    saving?: boolean;
    dirty?: boolean;
    savingState?: boolean;
    onDiscard?: (dirty: boolean) => void;
    onSave?: () => void;
    onDownload?: (raw: boolean, format?: string) => void;
    children?: React.ReactNode;
    footer?: React.ReactNode;
};

const ProcessBar: React.FC<ProcessBarProps> = ({
    processing = false,
    preparing = false,
    saving = false,
    dirty = false,
    savingState = false,
    onDiscard = () => {},
    onSave = () => {},
    onDownload = () => {},
    children,
    footer,
}) => {
    const actionGroup = (
        <div className="toolbar-section tool-bar-grp">
            {savingState && !processing && (
                <Stack direction="horizontal" gap={1} className="toolbar-status saving-status">
                    <Spinner animation="border" size="sm" role="status" />
                    <span>Saving...</span>
                </Stack>
            )}
            {!processing && !savingState && (
                <Button
                    className="toolbar-btn"
                    variant="outline-danger"
                    onClick={() => onDiscard(dirty)}
                    disabled={saving}
                >
                    {dirty ? "DISCARD" : "CLOSE"}
                </Button>
            )}
            {!processing && dirty && (
                <Button className="toolbar-btn" variant="outline-primary" onClick={onSave} disabled={saving || preparing}>
                    {!saving ? (
                        "Save"
                    ) : (
                        <Stack direction="horizontal" gap={1}>
                            <Spinner size="sm" />
                            Saving...
                        </Stack>
                    )}
                </Button>
            )}
            {!processing && (
                <Dropdown as={ButtonGroup}>
                    <Button disabled={preparing || saving} onClick={() => onDownload(false)}>
                        {!preparing ? (
                            <Stack direction="horizontal" gap={2}>
                                <Download size={16} />
                                Download
                            </Stack>
                        ) : (
                            <Stack direction="horizontal" gap={1}>
                                <Spinner size="sm" />
                                Preparing...
                            </Stack>
                        )}
                    </Button>
                    <Dropdown.Toggle split id="dropdown-split-basic" />
                    <Dropdown.Menu>
                        <Dropdown.Item onClick={() => onDownload(true)}>Download XML</Dropdown.Item>
                        <Dropdown.Item onClick={() => onDownload(true, "csv")}>Download CSV</Dropdown.Item>
                        <Dropdown.Item onClick={() => onDownload(true, "validation")}>Download Validation</Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            )}
            {processing && <>Processing</>}
        </div>
    );

    return (
        <div className="tool-bar">
            {children && (
                <div className="toolbar-row toolbar-summary">
                    <div className="toolbar-section toolbar-content">{children}</div>
                </div>
            )}
            <div className="toolbar-row toolbar-actions">
                <div className="toolbar-section toolbar-content">
                    {footer}
                </div>
                {actionGroup}
            </div>
        </div>
    );
};

export default ProcessBar;
